const lmz745 = [
    [
        -86.958828100000005,
        41.791968400000002
    ],
    [
        -86.907693899999998,
        41.7242988
    ],
    [
        -86.907829199999995,
        41.724239300000001
    ],
    [
        -86.907429999999991,
        41.723039
    ],
    [
        -86.906332199999994,
        41.722240599999999
    ],
    [
        -86.905433599999995,
        41.722339599999998
    ],
    [
        -86.9044265,
        41.722740099999996
    ],
    [
        -86.905429999999996,
        41.721638999999996
    ],
    [
        -86.9062299,
        41.721338999999993
    ],
    [
        -86.907432499999999,
        41.721538499999994
    ],
    [
        -86.909728999999999,
        41.724136299999991
    ],
    [
        -86.913330000000002,
        41.722537999999993
    ],
    [
        -86.916526700000006,
        41.716537399999993
    ],
    [
        -86.921928399999999,
        41.714836099999992
    ],
    [
        -86.922332699999998,
        41.713836599999993
    ],
    [
        -86.929329899999999,
        41.711137999999991
    ],
    [
        -86.932747500000005,
        41.710141499999992
    ],
    [
        -86.933021500000009,
        41.710197399999991
    ],
    [
        -86.937149000000005,
        41.708820299999992
    ],
    [
        -86.939950899999999,
        41.708085999999994
    ],
    [
        -86.943931500000005,
        41.706676399999992
    ],
    [
        -86.945419300000012,
        41.706340699999991
    ],
    [
        -86.947807000000012,
        41.705221999999992
    ],
    [
        -86.950719000000007,
        41.704261999999993
    ],
    [
        -86.975983000000014,
        41.694773999999995
    ],
    [
        -86.979583000000019,
        41.693029999999993
    ],
    [
        -86.986336000000023,
        41.690725999999991
    ],
    [
        -86.993118200000026,
        41.687908099999994
    ],
    [
        -86.998848000000024,
        41.685732999999992
    ],
    [
        -87.00126400000002,
        41.684612999999992
    ],
    [
        -87.003677300000021,
        41.68384549999999
    ],
    [
        -87.005599900000021,
        41.682868899999988
    ],
    [
        -87.013344000000018,
        41.680276899999988
    ],
    [
        -87.020286500000012,
        41.677379599999988
    ],
    [
        -87.021279600000014,
        41.677172999999989
    ],
    [
        -87.027885400000017,
        41.674659699999992
    ],
    [
        -87.034431400000017,
        41.672756099999994
    ],
    [
        -87.035980200000012,
        41.672069499999992
    ],
    [
        -87.036483100000012,
        41.672019999999989
    ],
    [
        -87.037792900000014,
        41.671412999999987
    ],
    [
        -87.038369000000017,
        41.67133299999999
    ],
    [
        -87.044096900000014,
        41.669188999999989
    ],
    [
        -87.045150700000008,
        41.668899499999988
    ],
    [
        -87.047279300000014,
        41.668899499999988
    ],
    [
        -87.048240600000014,
        41.668212799999985
    ],
    [
        -87.054209000000014,
        41.665956999999985
    ],
    [
        -87.058143600000008,
        41.664836799999982
    ],
    [
        -87.065025000000006,
        41.662180899999981
    ],
    [
        -87.069441000000012,
        41.660868999999984
    ],
    [
        -87.071647600000006,
        41.659988399999982
    ],
    [
        -87.076065,
        41.658644999999979
    ],
    [
        -87.076913000000005,
        41.658548999999979
    ],
    [
        -87.077453599999998,
        41.658195399999983
    ],
    [
        -87.081008999999995,
        41.657172999999986
    ],
    [
        -87.083122199999991,
        41.656371999999983
    ],
    [
        -87.097200599999994,
        41.652292999999986
    ],
    [
        -87.099075299999996,
        41.651508299999989
    ],
    [
        -87.108032199999997,
        41.649028699999988
    ],
    [
        -87.1096979,
        41.648756899999988
    ],
    [
        -87.121990999999994,
        41.645186999999986
    ],
    [
        -87.125794999999997,
        41.649300999999987
    ],
    [
        -87.125834999999995,
        41.650301999999989
    ],
    [
        -87.127636899999999,
        41.649980899999989
    ],
    [
        -87.130715600000002,
        41.650088899999986
    ],
    [
        -87.1316609,
        41.649812999999988
    ],
    [
        -87.132649000000001,
        41.649783899999989
    ],
    [
        -87.133499,
        41.649405999999992
    ],
    [
        -87.1353759,
        41.649024899999993
    ],
    [
        -87.138206999999994,
        41.649203699999994
    ],
    [
        -87.138687099999999,
        41.649013499999995
    ],
    [
        -87.140749999999997,
        41.649142999999995
    ],
    [
        -87.1458133,
        41.650094499999994
    ],
    [
        -87.146147999999997,
        41.647908999999991
    ],
    [
        -87.146023,
        41.63800599999999
    ],
    [
        -87.146522500000003,
        41.637534999999993
    ],
    [
        -87.146923999999999,
        41.637449999999994
    ],
    [
        -87.147789000000003,
        41.637393899999992
    ],
    [
        -87.147777000000005,
        41.637910999999995
    ],
    [
        -87.148858000000004,
        41.637967999999994
    ],
    [
        -87.148689200000007,
        41.642715399999993
    ],
    [
        -87.150003000000012,
        41.642761999999991
    ],
    [
        -87.149887000000007,
        41.643218899999994
    ],
    [
        -87.149188900000013,
        41.643291099999992
    ],
    [
        -87.148950000000013,
        41.644706699999993
    ],
    [
        -87.152736500000017,
        41.644664799999994
    ],
    [
        -87.183239600000022,
        41.723321399999996
    ],
    [
        -87.177684800000023,
        41.727033099999993
    ],
    [
        -87.145816000000025,
        41.733372199999991
    ],
    [
        -87.137801200000027,
        41.732624699999988
    ],
    [
        -87.136161200000032,
        41.732987099999988
    ],
    [
        -87.134660800000034,
        41.732936899999991
    ],
    [
        -87.130717000000033,
        41.733366199999992
    ],
    [
        -87.129893000000038,
        41.73323169999999
    ],
    [
        -87.125835000000038,
        41.733579199999987
    ],
    [
        -87.122604600000031,
        41.732936599999988
    ],
    [
        -87.118659600000029,
        41.732682199999985
    ],
    [
        -87.11639660000003,
        41.733334299999989
    ],
    [
        -87.098600200000035,
        41.738748799999989
    ],
    [
        -87.084408500000038,
        41.743795399999989
    ],
    [
        -87.081389800000039,
        41.744708899999992
    ],
    [
        -87.079149800000039,
        41.745839099999991
    ],
    [
        -87.075730100000044,
        41.746595499999991
    ],
    [
        -87.074874300000047,
        41.747120699999989
    ],
    [
        -87.074090300000051,
        41.74737669999999
    ],
    [
        -87.071563000000054,
        41.747796199999989
    ],
    [
        -87.058361500000061,
        41.752522099999986
    ],
    [
        -87.053829600000057,
        41.753792499999989
    ],
    [
        -87.047821800000051,
        41.755985599999988
    ],
    [
        -87.045212800000044,
        41.757215099999989
    ],
    [
        -87.029925200000051,
        41.762832899999992
    ],
    [
        -87.029298500000053,
        41.763243299999992
    ],
    [
        -87.026956000000055,
        41.764051499999994
    ],
    [
        -87.018272200000055,
        41.767636099999997
    ],
    [
        -87.015351700000053,
        41.768218299999994
    ],
    [
        -87.013226600000053,
        41.769542099999995
    ],
    [
        -87.010359000000051,
        41.770520499999996
    ],
    [
        -87.007851800000054,
        41.771712099999995
    ],
    [
        -87.006398800000056,
        41.772001099999997
    ],
    [
        -87.005258400000059,
        41.7727358
    ],
    [
        -86.979997100000062,
        41.782222699999998
    ],
    [
        -86.979162800000069,
        41.782393299999995
    ],
    [
        -86.976923800000066,
        41.783408099999995
    ],
    [
        -86.97381170000007,
        41.784350799999999
    ],
    [
        -86.972597200000067,
        41.785060999999999
    ],
    [
        -86.970091100000062,
        41.785644300000001
    ],
    [
        -86.967182100000059,
        41.786706200000005
    ],
    [
        -86.966275900000056,
        41.786994200000002
    ],
    [
        -86.958828100000005,
        41.791968400000002
    ]
];

export default lmz745;
